import { render, staticRenderFns } from "./BaseSimpleForm.vue?vue&type=template&id=9582bada&"
import script from "./BaseSimpleForm.vue?vue&type=script&lang=ts&"
export * from "./BaseSimpleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports